import React, { Fragment, useEffect, useState } from 'react'
import { Col, Container, Form, Row ,Toast} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerComboHitos } from '../../store/actions/cambio-gestion-action'
import { useLocation, useNavigate } from 'react-router-dom'
import Mensajes from '../mensajes'

const CambioGestion = ({formik,setIsHito,isHito,setShowToast, showToast}) => {
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const {  datosGestion } = data_recepciona
  const data_cambiarGestion = useSelector((state) => state.cambiarGestionReducer)
  const { cfg_form13, comboTipoGestion,comboCAmbitoGestion,comboHitos,respuestaCambiandoGestion } = data_cambiarGestion
  const [codTipoGestionNuevo, setCodTipoGestionNuevo]=useState("")
  const [codAmbitoGestionNuevo, setCodAmbitoGestionNuevo]=useState("")
  const [codHitoCambioGestion, setCodHitoCambioGestion]=useState("")
  const [fechaHitoCambioGestion, setFechaHitoCambioGestion]=useState("")
  const [minutaHitoCambioGestion, setMinutaHitoCambioGestion]=useState("")
  const [isData, setIsData]=useState(true)
  const {state}=useLocation()
  const dispatch = useDispatch()
  const history =useNavigate()

  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))
  useEffect(()=>{
    if(respuestaCambiandoGestion && respuestaCambiandoGestion.respuestaCambiandoGestion["code"]===1){
      setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000)
      
    }
  },[respuestaCambiandoGestion])
  useEffect(() => {
    setCodTipoGestionNuevo(
      datosGestion &&
        datosGestion.datosGestion[0]['codTipoGestion'] !== undefined &&
        datosGestion.datosGestion[0]['codTipoGestion'] !== null &&
        datosGestion.datosGestion[0]['codTipoGestion'] !== ''
        ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codTipoGestion"])
        : ''
     )
     setCodAmbitoGestionNuevo(
      datosGestion &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== null &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== ''
        ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"])
        : ''
     )
  }, [datosGestion]);
  
  const handleCloseToast = () => {
    setShowToast(false);
  }
  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{cfg_form13 && cfg_form13.cfg_form13['cambiotipogestion-title-cambiotg']}</div>
      {cfg_form13 && <Container>
        <Row>
          <Col md="3">
            <Form.Label
              className='mt-3'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-cmb-tipogestion']+" *"}
            </Form.Label>
            <br></br> 
            <Form.Select
                        className='mt-2'
                        aria-label='Default select example'                       
                        onChange={(e) => {
                          formik.handleChange(e)
                          setCodTipoGestionNuevo(e.target.value)
                          if(e.target.value!==""){
                            let query = Buffer.from(
                            JSON.stringify({"tipoGestion":datosGestion &&
                                                          datosGestion.datosGestion[0]['codTipoGestion'] !== undefined &&
                                                          datosGestion.datosGestion[0]['codTipoGestion'] !== null &&
                                                          datosGestion.datosGestion[0]['codTipoGestion'] !== ''
                                                          ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codTipoGestion"])
                                                          : '',
                                            "ambitoGestion":datosGestion &&
                                                                datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined &&
                                                                datosGestion.datosGestion[0]['codAmbitoGestion'] !== null &&
                                                                datosGestion.datosGestion[0]['codAmbitoGestion'] !== ''
                                                                ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"])
                                                                : '',
                                            "idSituacion":215003,
                                            "idModoIngreso":null
                                          })
                          ).toString('base64')
                          dispatch(obtenerComboHitos(query))
                          setIsData(false)
                          }
                        }}
                        name='codTipoGestionNuevo'
                        value={(formik.values.codTipoGestionNuevo = codTipoGestionNuevo)}
                        error={formik.errors.codTipoGestionNuevo}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboTipoGestion &&
                          comboTipoGestion.comboTipoGestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.codTipoGestionNuevo ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.codTipoGestionNuevo}
                    </Form.Text>
                  ) : (
                    ''
                  )}
          </Col>
          <Col md="3">
          <Form.Label
              className='mt-3'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-cmb-ambitogest']+" *"}
            </Form.Label>
            <br></br> 
            <Form.Select
                        className='mt-2'
                        aria-label='Default select example'                       
                        onChange={(e) => {
                          formik.handleChange(e)
                          setCodAmbitoGestionNuevo(e.target.value)
                          if(e.target.value!==""){
                            let query = Buffer.from(
                              JSON.stringify({"tipoGestion":datosGestion &&
                                                datosGestion.datosGestion[0]['codTipoGestion'] !== undefined &&
                                                datosGestion.datosGestion[0]['codTipoGestion'] !== null &&
                                                datosGestion.datosGestion[0]['codTipoGestion'] !== ''
                                                ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codTipoGestion"])
                                                : '',
                                              "ambitoGestion":datosGestion &&
                                                          datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined &&
                                                          datosGestion.datosGestion[0]['codAmbitoGestion'] !== null &&
                                                          datosGestion.datosGestion[0]['codAmbitoGestion'] !== ''
                                                          ?  parseInt(datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"])
                                                          : '',
                                              "idSituacion":215003,
                                              "idModoIngreso":null
                                            })
                          ).toString('base64')
                          dispatch(obtenerComboHitos(query))
                          setIsData(false)
                          }
                         
                        }}
                        name='codAmbitoGestionNuevo'
                        value={(formik.values.codAmbitoGestionNuevo = codAmbitoGestionNuevo)}
                        error={formik.errors.codAmbitoGestionNuevo}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboCAmbitoGestion &&
                          comboCAmbitoGestion.comboCAmbitoGestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.codAmbitoGestionNuevo ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.codAmbitoGestionNuevo}
                    </Form.Text>
                  ) : (
                    ''
                  )}
          </Col>
          <Col md="6">
          
          </Col>
          
        </Row>
        <Row>
          <Col md="3">
          <Form.Label
              className='mt-4'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-cmb-registrohito']}
            </Form.Label>
            <br></br> 
            <Form.Select
                        className='mt-2'
                        aria-label='Default select example' 
                        disabled={isData}                      
                        onChange={(e) => {
                          formik.handleChange(e)
                          setCodHitoCambioGestion(e.target.value)
                          setIsHito(e.target.value!=='' && !isHito) 
                        }}
                        name='codHitoCambioGestion'
                        value={(formik.values.codHitoCambioGestion = codHitoCambioGestion)}
                        error={formik.errors.codHitoCambioGestion}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboHitos &&
                          comboHitos.comboHitos?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
          </Col>
          <Col md="3">
          <Form.Label
              className='mt-4'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-imput-fechaocu']+" *"}
            </Form.Label>
            <br></br> 
            <Form.Control
                    className='mt-2'
                   
                    type='date'
                    value={(formik.values.fechaHitoCambioGestion = fechaHitoCambioGestion)}
                    
                    name='fechaHitoCambioGestion'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setFechaHitoCambioGestion(e.target.value)
                    }}
                    error={formik.errors.fechaHitoCambioGestion}
                  ></Form.Control>
                  {formik.errors.fechaHitoCambioGestion ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fechaHitoCambioGestion}
                    </Form.Text>
                  ) : (
                    ''
                  )}
          </Col>
          <Col md="6">
          <Form.Label
              className='mt-4'
              style={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {cfg_form13.cfg_form13['cambiotipogestion-input-comentario']}
            </Form.Label>
            <br></br> 
            <Form.Control
                          as='textarea'
                          className='mt-2 mb-2'
                          rows={2}
                          onChange={(e) => {
                            formik.handleChange(e)
                            setMinutaHitoCambioGestion(e.target.value)
                          }}
                          name='minutaHitoCambioGestion'
                          value={
                            (formik.values.minutaHitoCambioGestion = minutaHitoCambioGestion)
                          }
                          error={formik.errors.minutaHitoCambioGestion}
                        />
                        {formik.errors.minutaHitoCambioGestion ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.minutaHitoCambioGestion}
                          </Form.Text>
                        ) : (
                          ''
                        )}
          </Col>
          <Col> 
            {respuestaCambiandoGestion && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={5000}
                    responseData={respuestaCambiandoGestion?.respuestaCambiandoGestion}
                ></Mensajes>
              }
          </Col>
        </Row>
        <hr style={{ color: '#04005D', height: '2px' }}></hr>
      </Container>}
    </>
  )
}

export default CambioGestion
